import axios from '@/config/axios.config';
import store from '@/store';
import { logEvent } from '@/helpers/cieloLogger';
import vars from '@/config/vars';
import { messageCodes, getMessageLangParameter, getTitleMessageLangParameter } from '@/models/MessageCodes';

import Swal from 'sweetalert2';

export default class BaseProcessor {
    constructor(multiLanguage) {
        this.multiLanguage = multiLanguage;
    }

    /**
     * Envia a transação para o checkout
     */
    async SendTransactionRequest() {
        // SIMULADO
        if (vars.USE_SIMULATED_MODE) {
            return await new Promise(resolve => {
                setTimeout(() => {
                    let response = {
                        data: {
                            'Data': {
                                'Success': true,
                                'Type': 0,
                                'Data': {
                                    'Redirect': false,
                                    'OrderId': '4a1b722f-8eaf-4d67-b1e2-2f69b9d5bda3',
                                    'CreatedDate': '18/12/2022 15:12:56',
                                    'preorderId': '4a1b722f-8eaf-4d67-b1e2-2f69b9d5bda3',
                                    'OrderNumber': 'a5d50d9be3b245268c6f093d42a9d085',
                                    'CustomerEmail': 'mobileguest00000@cielo.com.br',
                                    'MerchantName': 'Diogo Mello',
                                    'BoletoViewerUrl': 'https://transactionsandbox.pagador.com.br/post/Boleto/Issue/215a116f-859b-441f-89a6-f213bafaf6d0',
                                    'BoletoNumber': '00091234155000000000550012345604183160000001710',
                                    'Url': 'https://www.google.com/',
                                }
                            }
                        }
                    };
                    resolve(response.data.Data);
                    this.HandleSuccessTransaction(response.data.Data);
                }, 3000);
            });
        }

        // PRODUÇÃO
        try {
            let response = await axios.post('/preorder', this.contract);

            return this.HandleSuccessTransaction(response.data.Data);
        }
        catch (error) {
            logEvent({
                category: 'checkout',
                action: 'resumo_compra_checkout_error',
                label: `Erro ao finalizar pagamento: ${error || 'Sem mensagem'}`
            });

            this.ShowUnexpectedError();
        }
    }

    /**
     * Monta o contrato com os campos base
     * @param {Object} contractObject Campos a serem inseridos no contrato
     */
    BuildContract(contractObject) {
        this.contract = {
            ...store.getters['preorder/getSubmitModel'],
            ...store.getters['payment/getSubmitModel'],
            ...store.getters['recurrentPayment/getSubmitModel'],
            ...store.getters['customer/getSubmitModel'],
            ...store.getters['shippingAddress/getSubmitModel'],
            ...store.getters['shippingType/getSubmitModel'],
            ...store.getters['antifraud/getSubmitModel'],
            isGuest: true,
            ...contractObject,
        };
    }

    /**
     * Trata uma resposta de sucesso.
     * @param {Object} response Reposta da api
     */
    HandleSuccessTransaction(response) {
        if (!response)
            return this.ShowUnexpectedError();

        if (response.Success) {
            const paymentType = store.getters['payment/getSelectedPaymentMethod'] || {};
            logEvent({
                category: 'checkout',
                action: 'resumo_compra_checkout',
                label: `Usuário confere informações do pedido antes de finalizar | PaymentType: ${paymentType.PaymentType || 'Não definido'}`
            });

            store.commit('preorder/setTransactionSuccessfulResponse', response.Data);

            return response;
        }

        let errorMessage = this.multiLanguage
            .get(getMessageLangParameter(response.MessageCodes[0]));

        let errorTitleMessage= this.multiLanguage
            .get(getTitleMessageLangParameter(response.MessageCodes[0]));

        if(response.MessageCodes[0] === messageCodes.OPENFINANCEURL_IS_NULL && !response.Data.linkUrl) {
            errorMessage = this.multiLanguage.get('tryCreateNewLink');
        }

        Swal.fire({
            type: 'error',
            title: errorTitleMessage,
            text: errorMessage,
            confirmButtonText: !!response.Data.linkUrl ? this.multiLanguage.get('retry') : 'Ok',
        }).then((result) => {
            if (result.value && response.Data.linkUrl) {
                window.location.href = response.Data.linkUrl;
            }
        });

        logEvent({
            category: 'checkout',
            action: 'resumo_compra_checkout',
            label: `[ERROR]: ${response.Message || this.multiLanguage.get('withoutMessage')}`
        });
    }

    /**
     * Redireciona para a url do merchant
     * @param {String} url Url do Merchant
     */
    RedirectToMerchantUrl(url) {
        window.location.href = url;
    }

    /**
     * Exibe uma mensagem de erro na tela
     */
    ShowUnexpectedError() {
        Swal.fire({
            type: 'error',
            title: 'Oppsss!',
            text: this.multiLanguage.get('paymentProviderPurchaseError')
        });
    }

    /**
     * Valida se a resposta é de sucesso
     * @param {Object} response Resposta da api
     */
    ResponseIsSuccess(response) {
        if (!response) return false;
        if (!response.Success) return false;

        return true;
    }
}
